import { RequestPriorityCatalog } from "@/components/admin/RequestPriorityCatalog";

export function SettingsRequestPrioritiesPage() {
  return <RequestPriorityCatalog />;
}
